import { requestTimeout } from '@/partials/el.Utils.js';

elabs.Header = class {
  constructor() {
    if (elabs.Header.instance) {
      // This is a singleton, do not allow more than once instance
      return elabs.Header.instance;
    }
    elabs.Header.instance = this;
    this.initialise();
  }

  initialise = () => {
    this.view = document.querySelector('.el-header');
    this.view.classList.add('el-header--initialized');
    requestTimeout(() => {
      this.view.classList.add('el-header--initialized-complete');
    }, 1210);
    this.lastScrollY = 0;
    this.isOpaque = false;

    this.cartIconBubbleWrapper = document.getElementById('header-cart-icon-bubble');

    requestTimeout(() => {
      this.handleScrollEvent(null, window.scrollY, true);
      window.addEventListener('WINDOW_SCROLL_EVENT', (e) => {
        this.handleScrollEvent(e, e.detail.scrollY);
      });
    }, 2000); // Do not start the scroll event stuff until page has fully settled/loaded

    document.addEventListener('cart:updated', this._onCartUpdate.bind(this));

    this.calculateScrollOffsetWhenWeAreBeyondTheDocumentHeight();
    setTimeout(() => {
      this.calculateScrollOffsetWhenWeAreBeyondTheDocumentHeight();
    }, 3000);
    setTimeout(() => {
      this.calculateScrollOffsetWhenWeAreBeyondTheDocumentHeight();
    }, 6000);
    document.addEventListener('WINDOW_RESIZED_EVENT', () => {
      this.calculateScrollOffsetWhenWeAreBeyondTheDocumentHeight();
    });

    if (document.querySelector('.header-group--always-opaque')) {
      // the header is always opaque
      this.calculateHeaderSpacerHeight();
      document.addEventListener('WINDOW_RESIZED_EVENT', () => {
        this.calculateHeaderSpacerHeight();
      });
    }
  };

  _onCartUpdate = (event) => {
    if (!event || !event.detail) {
      return;
    }
    const { cart } = event.detail;

    if (!this.cartIconBubbleWrapper || !cart?.sections?.['cart-icon-bubble']) {
      return;
    }
    const newHtml = cart.sections['cart-icon-bubble'];
    this.cartIconBubbleWrapper.innerHTML = newHtml;
  };

  // For when the header is always opaque, we need to add a spacer so that the content lays out
  // below the header at the top of the page... the space required needs to be calculated because
  // the header height is dynamic, depending on page width
  calculateHeaderSpacerHeight = () => {
    if (!this.spacer) {
      this.spacer = document.querySelector('.header-group__spacer');
    }

    const { height } = this.view.getBoundingClientRect();
    this.spacer.style.height = `${height}px`;
  };

  // this is used so that when you get to the bottom of the page and go beyond, and it bounces back, the header does not annoyingly appear.
  // This is called rubber band scrolling, and it happens on some mobiles, and also on Safari.
  calculateScrollOffsetWhenWeAreBeyondTheDocumentHeight = () => {
    const docHeight = document.body.scrollHeight;
    const windowHeight = window.innerHeight;
    this.ignoreScrollsBeyondOffset = docHeight - windowHeight - 30; // 30px tolerance
  };

  handleScrollEvent = (evt, scrollY) => {
    if (scrollY < this.lastScrollY - 3) {
      this.view.classList.remove('el-header--hidden');
      this.lastScrollY = scrollY;
    } else if (scrollY > 100 && scrollY > this.lastScrollY + 10 && scrollY < this.ignoreScrollsBeyondOffset) {
      this.view.classList.add('el-header--hidden');
      requestTimeout(() => {
        this.view.classList.add('el-header--opaque');
        this.isOpaque = true;
      }, 300); // Delay to allow the header to hide before making it opaque
      this.lastScrollY = scrollY;
    }
    if (this.isOpaque && scrollY < 100) {
      this.view.classList.remove('el-header--opaque');
      this.isOpaque = false;
    }
  };
};

elabs.onJavascriptReady(() => {
  elabs.Header = new elabs.Header();
});
